
  $(document).ready(function(){

    $("body").on("click", ".clio-country ul, .clio-country-newsletter ul", function(e){
      $(this).toggleClass('hover');
    })
    
    $("body").on("click", ".clio-country ul li", function(e){
      e.preventDefault();
      let lang = $(this).attr("data-lang");
      const popup = $(this).closest(".popup-country").length;
      set_country(lang, popup);
    })

    $('.clio-country-newsletter option[value="---"]').html('Your country').attr("value", "").prevAll().remove();
    $('.clio-country-newsletter option[value="Italy"]').remove();
    
    /*
    $(".main-header h1.title a").click(function(e){
      e.preventDefault();
      set_country();
      location.reload();
    })*/
          
    function set_country(lang = "", popup = 0) {
      var d = new Date();
      d.setTime(d.getTime() + (5184000000));
      var expires = "expires="+d.toUTCString();
      document.cookie = "country=" + lang + ";" + expires + ";path=/";
      $(".clio-country ul li.selected").removeClass("selected");
      $(".clio-country ul li[data-lang='"+lang+"']").addClass("selected");
      if(!popup) {
        if(lang=="IT" && (clio_strings.locale.code !== "IT")){
          window.location.replace('https://cliomakeupshop.com?lang=IT');
        } else if(lang!=="IT" && (clio_strings.locale.code == "IT")) {
          window.location.replace('https://international.cliomakeupshop.com');
        } else {
          //$(".clio-country ul").removeClass('hover');
        }
      }
    }
    
    function read_country() {
      if(!clio_strings.locale.enabled) { 
        return 1;
      }
      var cookieCountry = "";
      var ca = document.cookie.split(';');
      for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf("country=") == 0) {
          cookieCountry = c.substring("country=".length, c.length);
        }
      }
      if(!cookieCountry) {
        const urlParams = new URLSearchParams(window.location.search);
        if(urlParams.has('lang')) {
          valid_countries = [ "IT", "UK", "FR", "CH", "DE", "ES", "NL", "IE", "W" ];
          cookieCountry = urlParams.get("lang");
          if(valid_countries.includes(cookieCountry)) {
            set_country(cookieCountry, 1);
          } else {
            cookieCountry = "";
          }
        }
      }
      return cookieCountry;
    }
    
    var initlang = read_country();
    if(initlang) {
      initlang = clio_strings.locale.code == "INT" ? "W" : "IT";
      $(".clio-country ul li[data-lang='" + initlang + "']").addClass("selected");
    } else {
      var gatepage = $("body").hasClass('template-password');
      if(!gatepage) {
        if(clio_strings.locale.code == "IT") {
          set_country("IT", 1);
        } else {
          set_country("W", 1);
        }
      }
    }
    
    $("body").on("click", ".popup-country a[href='#newsletter']", function(e){
      e.preventDefault();
      $(".popup-country").addClass("disabled");
    })
    
    $("body").on("click", ".popup-country .subscribe", function(e){
      e.preventDefault();
      if(read_country()=="IT" && (clio_strings.locale.code !== "IT")) {
        window.location.replace('https://cliomakeupshop.com?lang=IT');
      } else if(read_country()!=="IT" && (clio_strings.locale.code == "IT")) {
        window.location.replace('https://international.cliomakeupshop.com');
      } else {
        $(".popup-modal-close").trigger("click");
      }
    })
    
    // international ^^
    
    //viewitem on variant change
    window.firstvariantchange = true;
    document.addEventListener('variant:changed', function(event) {
      const variant = event.detail.variant;
      if(window.firstvariantchange) { window.firstvariantchange = false; return; }
      if(!variant) { return; }
      window.analyzify?.gtmViewItem(window.analyzify.getProductObj, variant.id);
    });

    //accordion
    $('.accordion').each(function(){
      $(this).unwrap('strong').unwrap('p');
      $(this).text($(this).text())
    });
    $('.accordion').each(function(){
      $(this).next().nextUntil(".accordion").andSelf().wrapAll("<div></div>");
      $(this).click(function(e){ e.preventDefault(); $(this).toggleClass('active') })
    });

    //form animation
    document.addEventListener('widgetform_send', function (e) {
      $("button.subscribe .icon").click()
      fbq('trackCustom', 'Newsletter', {type: 'default'})
    }, false);
    
    document.addEventListener('restockform_send', function (e) {
      $("button.subscribe .icon").click()
      fbq('trackCustom', 'Newsletter', {type: 'restock'})
    }, false);
    
    timeout = "";
    $(".quantity a").click(function(e){
      e.preventDefault();
      $input = $(this).parent().find("input");
      qu = $input.val();
      maxvalue = parseFloat($input.attr("data-maxi"));
      if ($(this).hasClass("plus")) {
        var newVal = parseFloat(qu) + 1;
        if(maxvalue) {
          if(newVal>maxvalue) {
            newVal = maxvalue;
            return;
          }
        }
      } else {
        if (qu > 1) {
          var newVal = parseFloat(qu) - 1;
        } else {
          newVal = 1;
        }
      }
      $input.val(newVal);
      if(timeout) { clearInterval(timeout); }
      timeout = setTimeout(function(){
        //$("input[name=update]").click();
      }, 800);
    })
    
    $("a.updatecart").click(function(e){
      e.preventDefault();
      $("input[name=update]").click();
    })
    
    
    setTimeout( function() {
      var form = document.querySelector('#subscribe-form-popup');
      if(form) { document.dispatchEvent(new CustomEvent('ClioLoadLightWidget', { detail: form })); }
    }, popup_config.seconds_until * 1000 + 1000);
    
    //cookie fix
    setTimeout( function() { $(".cookie-space").height($(".cc_container").outerHeight()); }, 1000);
    $(".cc_btn").click(function(){ $(".cookie-space").height(0); })
    
    //back to top
    $(window).scroll(function(){
      if($(window).scrollTop() > 500 ) {
        if(!$('.backtop').hasClass("up")) { $('.backtop').addClass("up"); }
      } else {
        if($('.backtop').hasClass("up")) { $('.backtop').removeClass("up"); }
      }
    });
    
    //anchor
    $('a[href="#clio-newsletter-modal"]').click(function(e){
      e.preventDefault()
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', popup_klaviyo_form]);
    })
    
    //swiper free scroll slider
    var swiper = new Swiper('.product-slider-new .swiper-container', {
      slidesPerView: 1,
      spaceBetween: 0,
      freeMode: true,
      freeModeSticky: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        420: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
        1280: { slidesPerView: 4 },
        1600: { slidesPerView: 5 },
        1920: { slidesPerView: 6 }
      }
    });
    
    //fetch promotions
    if(clio_strings.promotions.disable) {
      localStorage.removeItem("cmushop_promos")
    } else {
      if(clio_strings.promotions.endpoint && !$('body').hasClass('template-cart')) {
        if(localStorage.getItem("cmushop_promos") === null) {
          downloadPromos()
        } else {
          let promos = JSON.parse(localStorage.getItem("cmushop_promos"));
          const now = new Date()
          if(now.getTime() > promos.slice(-1).pop()) {
            localStorage.removeItem("cmushop_promos")
            downloadPromos()
          } else {
            clioNotify(promos);
          }
        }
      }
      $('body').on("click", ".clio-notify .button, .notify-toggle", function(e){
        $('.clio-notify').removeClass("expo")
        e.preventDefault();
        if(localStorage.getItem("cmushop_notify") === null) {
          const now = new Date()
          localStorage.setItem("cmushop_notify", now.getTime() + 10800000)
          if(window.clio_minicart_pause) {
            const event = new Event('linkRecentCartItemPopUp')
            window.dispatchEvent(event)
          }
        } else {
          localStorage.removeItem("cmushop_notify")
        }
        $(".clio-notify").toggleClass("closed");
      })
      $('body').on("cartUpdate", function(e, totalraw){
        localStorage.removeItem("cmushop_notify")
        const total = typeof totalraw === 'number' ? totalraw : parseFloat(totalraw.replace("€", "").replace("$", ""));
        let promos = JSON.parse(localStorage.getItem("cmushop_promos"));
        clioNotify(promos, total, true);
      })
    }
    function downloadPromos() {
      const now = new Date()
      let promos = [];
      fetch(clio_strings.promotions.endpoint).then(response => { return response.json() }).then(data => {
        if("promotions" in data) {
          promos = data.promotions;
          promos.push(now.getTime() + 900000);
          localStorage.setItem("cmushop_promos", JSON.stringify(promos));
          clioNotify(promos);
        }
      })
    }
    function clioNotify(promos, total, delayMiniCart=false) {
      const now = new Date()
      let notify = false;
      if(!total) { total = clio_strings.total }
      promos.forEach(function(promo) {
        if(typeof promo === 'object' && promo !== null) {
          let promo_image = promo.image
          const promo_notifyafter = promo.conditions.notify_after
          const promo_type = promo.conditions.typology
          const promo_start = new Date((promo.start_time).replace(' ', 'T'));
          const promo_end = new Date((promo.end_time).replace(' ', 'T'));
          if(now.getTime() > promo_start.getTime() && now.getTime() < promo_end.getTime()){
            if(promo_type=="PRICE") {
              const price_type = promo.conditions.check;
              const price = promo.conditions.value;
              if(price_type == 'OVER-EQUAL-PRICE') {
                if(total > promo_notifyafter && total < price) {
                  notify = true;
                  if(promo.actions.hasOwnProperty('items')) {
                    const products_gift = promo.actions.items;
                    promo_image = products_gift[0].image;
                    promo_title = products_gift[0].title;
                  } else {
                  	promo_image = promo.image;
                    promo_title = promo.name;
                  }
                  if(promo_image.includes('cliomakeup-GIFT-CARD1')) {
                    promo_image = 'https://cliomakeupshop.com/cdn/shop/files/GIFT-Cliomakeup-v2_1_128x128.png?v=1687794588';
                  }
                  $(".clio-notify, .notify-toggle").remove();
                  const remain = price - total;
                  const isCart = $('body').hasClass('template-cart');
                  const priceText = price == 20 ? '2 prodotti' : (price + '€');
                  const message = clio_strings.promotions.notify_banner.replace("%PRODUCT%", '<strong>' + promo_title + '</strong>').replace("%MONEY%", '<strong>' + remain.toFixed(2) + '€</strong>')
                  const progressBar = '<ul class="promo-progress-bar"><li style="left: 100%;"><strong style="width: auto; right: 0; left: auto; white-space:nowrap">' + priceText + '</strong></li><li style="width:' + Math.min(total * 100 / price, 100) + '%" class="progress"></li></ul>';
                  $('body').prepend('<div class="clio-notify closed"><section><div><img src="' + promo_image + '"/><p>' + message + '</p></div>' + progressBar + '<a class="btn button" href="#">'+ clio_strings.promotions.notify_banner_button +'</a></section></div>');
                  if(!isCart) {
                    $('<a href="#" class="notify-toggle"><span class="entypo-bell"><span class="number-wrapper "><span class="number">1</span></span></span></a>').insertAfter('.cart-link');
                  }
                  const notifyexpo = sessionStorage.getItem("cmushop_notifyexpo")
                  const expiry = localStorage.getItem("cmushop_notify");
                  if(notifyexpo) {
                    //
                  } else {
                    sessionStorage.setItem("cmushop_notifyexpo", true)
                    $('.clio-notify').addClass("expo") 
                  }
                  const now = new Date()
                  if((!isCart) && (expiry === null || now.getTime() > expiry)) {
                    localStorage.removeItem("cmushop_notify");
                    const delay = delayMiniCart ? 10 : 1000;
                    setTimeout(function(){ $('.clio-notify').removeClass("closed") },delay)
                    setTimeout(function(){ $('.clio-notify .promo-progress-bar').addClass('animate'); }, delay + 500)
                  } else {
                    $('.clio-notify .promo-progress-bar').addClass('animate');
                  }
                }
              }
            }
          }
        }
      })
      if(!notify) {
        window.clio_minicart_pause = false
        $(".clio-notify, .notify-toggle").remove();
      } else if(delayMiniCart) {
        window.clio_minicart_pause = true
      }
    }
  });
